import React, {FC, memo} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {InboxModel} from '../../../../../models/api/inboxModel';

/*
 * Props.
 */

interface CellInboxColorProps {
  inbox: InboxModel;
}

/*
 * Style.
 */

interface WrapperStyleProps {
  $color: string;
}
const StyledWrapperDiv = styled.div<WrapperStyleProps>`
  position: absolute;
  top: 0;
  right: 0;
  color: ${(p) => p.$color};
`;

/*
 * Component.
 */

export const CellInboxColor: FC<CellInboxColorProps> = memo(({inbox}) => {
  // If the inbox color is white, nothing to display.
  const color = inbox.color.toLowerCase();
  if (color === '#ffffff') {
    return null;
  }

  // Otherwise, render the color indicator.
  return (
    <StyledWrapperDiv $color={inbox.color}>
      <Icon name="northEastTriangle" size={14} />
    </StyledWrapperDiv>
  );
});
